class ReelSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slider = this.querySelector('[data-reel="slider"]');
    this.slider.addEventListener('scrollend', this.onScrollEnd.bind(this));

    this.buttonPrev = this.querySelector('button[data-reel="prev"]');
    this.buttonNext = this.querySelector('button[data-reel="next"]');

    this.buttonPrev.addEventListener('click', this.onClickPrev.bind(this));
    this.buttonNext.addEventListener('click', this.onClickNext.bind(this));
  }

  onClickPrev(_event) {
    this.slide('prev');
  }

  onClickNext(_event) {
    this.slide('next');
  }

  onScrollEnd() {
    let { scrollLeft, scrollWidth, offsetWidth } = this.slider;

    this.buttonPrev.disabled = scrollLeft <= 0;
    this.buttonNext.disabled = scrollLeft + offsetWidth >= scrollWidth;
  }

  slide(direction) {
    let items = this.querySelectorAll('[data-reel="item"]');

    let { scrollLeft } = this.slider;
    let scrollOffsetLeft = items[0].offsetLeft;

    let roundingErrors = 10;

    if (direction === 'next') {
      // Find item to scroll to:
      for (let item of items) {
        if (scrollLeft < item.offsetLeft - scrollOffsetLeft - roundingErrors) {
          item.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });

          break;
        }
      }
    }

    if (direction === 'prev') {
      // Find item to scroll to:
      for (let item of [...items].reverse()) {
        if (scrollLeft > item.offsetLeft - scrollOffsetLeft + roundingErrors) {
          item.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'start',
          });

          break;
        }
      }
    }
  }
}

customElements.define('reel-slider', ReelSlider);
